<template>
  <v-dialog :value="dialogProp.show" persistent max-width="700">
    <v-card class="elevation-12">
      <v-toolbar :dark="$vuetify.theme.dark" color="primary">
        <v-toolbar-title>
          {{ $t('Подписка на рассылку') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-row v-if="!!generalError || isLoading" class="my-0 py-0 mx-1">
        <v-col cols="12">
          <v-progress-linear :active="isLoading" color="loader" indeterminate />
        </v-col>
        <v-col class="mx-1">
          <general-error v-if="!!generalError" />
        </v-col>
      </v-row>
      <v-card-text class="pt-3">
        <v-row
            v-for="subscription in subscriptions"
            :key="subscription.subscriptionsType"
            align-content="center"
            class="ma-0">
          <v-col cols="10">
            <v-checkbox
                v-model="subscription.enabled"
                v-test="{ checkbox: subscription.subscriptionsType }"
                :label="$t(subscription.description)" />
          </v-col>
        </v-row>
        <v-expansion-panels v-if="showBlackList">
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-row align-content="center">
                <v-col cols="12">
                  {{ $t('Черный список организаций') }}
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content eager>
              <v-row class="py-2">
                <v-col>
                  <black-list-selection
                      v-model="blackLists"
                      :items="organizations"
                      :label="$t('Организация')"
                      :search-label="$t('Поиск организации')" />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
            id="cancelBtn"
            v-test="{ btn: 'cancel' }"
            color="primary"
            @click.stop="cancel">
          {{ $t('Закрыть') }}
        </v-btn>
        <v-btn
            id="savelBtn"
            v-test="{ btn: 'save' }"
            color="primary"
            :disabled="isLoading"
            @click.stop="continueOperation">
          {{ $t('Сохранить') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import GeneralError from './GeneralError.vue'
  import BlackListSelection from '@/components/reused/ui/BlackListSelection.vue'
  import { mapActions, mapState } from 'vuex'
  import { ORGANIZATION_MANAGEMENT } from '@/constants/store.js'
  import { PARTICIPANT_TYPES } from '@/constants/business.js'

  export default {
    components: {
      GeneralError,
      BlackListSelection
    },
    props: {
      mailing: {
        type: Object,
        default: () => ({})
      },
      dialogProp: {
        type: Object,
        default: () => {
          return {
            show: false,
            callback: null
          }
        }
      }
    },
    data () {
      return {
        isLoading: false,
        params: {
          participantType: PARTICIPANT_TYPES.ORGPART
        },
        subscriptions: [],
        blackLists: []
      }
    },
    computed: {
      ...mapState(ORGANIZATION_MANAGEMENT.NAMESPACE, {
        organizations: state => (state[ORGANIZATION_MANAGEMENT.STATE.BLACK_LIST] || [])
      }),
      showBlackList () {
        return this.isParticipant
      }
    },
    watch: {
      mailing: {
        immediate: true,
        deep: true,
        handler: function (newValue) {
          if (newValue?.subscriptions &&
          newValue.subscriptions.length) {
            this.subscriptions = newValue.subscriptions.map(m => ({
              ...m,
              enabled: !m.disabled
            }))
            this.blackLists = newValue.blackLists || []
          }
        }
      }
    },
    created () {
      if (!this.organizations.length) {
        this.getOrganizationsBlackList()
      }
    },
    methods: {
      ...mapActions(ORGANIZATION_MANAGEMENT.NAMESPACE, {
        getOrganizationsBlackListAction: ORGANIZATION_MANAGEMENT.ACTIONS.GET_ORGANIZATIONS_BLACK_LIST
      }),
      continueOperation: async function () {
        try {
          if (this.dialogProp.callback) {
            this.isLoading = true
            const mailing = {
              subscriptions: this.subscriptions.map(s => ({
                subscriptionsType: s.subscriptionsType,
                disabled: !s.enabled
              })),
              blackLists: this.blackLists
            }
            await this.dialogProp.callback(mailing)
            this.isLoading = false
            this.cancel()
          }
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      getOrganizationsBlackList: async function () {
        try {
          this.isLoading = true
          await this.getOrganizationsBlackListAction(this.params)
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
